// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","closeButton":"closeButton-_hOi5"};